import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AnalyticsConsent from "@/components/AnalyticsConsent";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-bone-light">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AnalyticsConsent />
    </div>
  );
}
